// extracted by mini-css-extract-plugin
export var video = "video-Iuq";
export var player = "player-a0v";
export var play_button = "play_button-3UG";